'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var COMPANY = exports.COMPANY = 'COMPANY';
var USERS_AND_TEAMS = exports.USERS_AND_TEAMS = 'USERS_AND_TEAMS';
var OWNER = exports.OWNER = 'OWNER';